import { ProgressBar } from 'react-bootstrap'

export default function LEProgress(){
    return(
        <>
            <p><strong>Learn and Earn Progress</strong></p>
            <ProgressBar variant="success" animated now={45} className="rounded-pill mb-3"/>
            <p className="h7"><strong className="h5 font-weight-bold">8</strong> reviews needed to earn reward</p>
        </>
    )
}